import { memo as Memo, useMemo } from 'react';

//* Components
import Text from '@/components/global/Text';
import Image from '@components/global/Image';
import CustomLink from '@components/global/CustomLink';
import CustomLottie from '@/components/global/CustomLottie';

//* Styles
import SubServiceStyle from './style';

const SubService = Memo(({ title, description, image, itemNumber, href }) => {
	const iNumber = useMemo(() => {
		return `${itemNumber < 9 ? `0${itemNumber + 1}` : itemNumber + 1}`;
	}, [itemNumber]);

	return (
		<SubServiceStyle>
			<CustomLink
				url={href}
				className={'weOfferListItemWrapper'}>
				<div className={'offerContainer'}>
					<div className={'listItemImgWrapper'}>
						{image.type === 'document' ? (
							<CustomLottie animData={image.dataJson} />
						) : image.type === 'image' ? (
							<Image
								alt={image?.alt}
								src={image?.src}
								className={'listItemImage'}
							/>
						) : null}
					</div>

					<div className={'listItemContentWrapper'}>
						<div className={'listItemContentContainer'}>
							<div className={'titleWrapper'}>
								<Text
									tag={'h4'}
									className='h6 font-poppins font-regular'>
									{title}
								</Text>
							</div>

							<div className={'descWrapper'}>
								<Text className={`p font-poppins font-light`}>{description}</Text>
							</div>
						</div>

						<div>
							<Text className={`p-m font-anonymous font-regular`}>{iNumber}</Text>
						</div>
					</div>
				</div>
			</CustomLink>
		</SubServiceStyle>
	);
});

export default SubService;
